import { Link } from "react-router-dom";

const articles = [
  {
    slug: "o-que-e-cssbuy-spreadsheet",
    title: "O que &eacute; CSSBuy Spreadsheet e Como Funciona?",
    excerpt: "Descubra tudo sobre o CSSBuy Spreadsheet, a ferramenta que est&aacute; revolucionando as compras da China. Guia completo para iniciantes com exemplos pr&aacute;ticos.",
    date: "Junho 2026",
    tag: "Guia Essencial",
    image: "https://readdy.ai/api/search-image?query=Modern%20clean%20desk%20workspace%20with%20large%20monitor%20showing%20colorful%20spreadsheet%20data%20charts%2C%20warm%20oak%20desk%20surface%2C%20editorial%20office%20photography%2C%20soft%20natural%20window%20light%20from%20left%2C%20ceramic%20coffee%20mug%20and%20small%20succulent%20plant%2C%20minimalist%20productive%20atmosphere%2C%20warm%20terracotta%20and%20cream%20tones&width=600&height=400&seq=blog-card-v2-a1b2&orientation=landscape",
  },
  {
    slug: "como-usar-cssbuy-spreadsheet-passo-a-passo",
    title: "Como Usar CSSBuy Spreadsheet Passo a Passo",
    excerpt: "Aprenda o fluxo completo de compras usando CSSBuy Spreadsheet. Da escolha do produto at&eacute; a entrega final, tudo explicado em detalhes para iniciantes.",
    date: "Junho 2026",
    tag: "Tutorial",
    image: "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20keyboard%20with%20shopping%20interface%20on%20screen%2C%20warm%20desk%20with%20notebook%20and%20pen%20beside%2C%20editorial%20workspace%20photography%2C%20soft%20morning%20light%20creating%20gentle%20glow%2C%20organized%20creative%20setup%2C%20warm%20beige%20and%20olive%20tones%2C%20calm%20focused%20atmosphere&width=600&height=400&seq=blog-card-v2-c3d4&orientation=landscape",
  },
  {
    slug: "cssbuy-spreadsheet-e-confiavel",
    title: "CSSBuy Spreadsheet &eacute; Confi&aacute;vel? An&aacute;lise Completa",
    excerpt: "An&aacute;lise detalhada sobre a seguran&ccedil;a e confiabilidade do CSSBuy Spreadsheet. Entenda os riscos e descubra como comprar com prote&ccedil;&atilde;o total.",
    date: "Junho 2026",
    tag: "Seguran&ccedil;a",
    image: "https://readdy.ai/api/search-image?query=Secure%20padlock%20icon%20floating%20above%20a%20warm%20cream%20workspace%20with%20financial%20documents%20and%20laptop%2C%20editorial%20security%20concept%20photography%2C%20soft%20directional%20lighting%20creating%20dramatic%20shadows%2C%20trust%20and%20safety%20theme%2C%20warm%20neutral%20tones%20with%20sage%20green%20accents%2C%20professional%20corporate%20aesthetic&width=600&height=400&seq=blog-card-v2-e5f6&orientation=landscape",
  },
  {
    slug: "melhor-cssbuy-spreadsheet-2026",
    title: "Melhor CSSBuy Spreadsheet 2026: Guia de Escolha",
    excerpt: "Compara&ccedil;&atilde;o das melhores planilhas CSSBuy dispon&iacute;veis em 2026. Velocidade, precis&atilde;o e atualiza&ccedil;&atilde;o analisadas para voc&ecirc; escolher a ideal.",
    date: "Junho 2026",
    tag: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=Spreadsheet%20comparison%20charts%20displayed%20on%20dual%20monitors%20in%20a%20bright%20modern%20office%2C%20editorial%20workspace%20photography%2C%20soft%20natural%20light%20through%20sheer%20curtains%2C%20organized%20professional%20desk%20setup%2C%20warm%20sand%20and%20terracotta%20color%20accents%2C%20clean%20contemporary%20aesthetic&width=600&height=400&seq=blog-card-v2-g7h8&orientation=landscape",
  },
  {
    slug: "cssbuy-vs-pandabuy-vs-sugargoo",
    title: "CSSBuy vs Pandabuy vs Sugargoo: Qual o Melhor?",
    excerpt: "Compara&ccedil;&atilde;o completa entre os principais agentes de compras. Taxas, velocidade de entrega, seguran&ccedil;a e suporte ao cliente analisados em detalhes.",
    date: "Junho 2026",
    tag: "Comparativo",
    image: "https://readdy.ai/api/search-image?query=Three%20distinct%20brand%20cards%20arranged%20on%20a%20warm%20linen%20surface%20showing%20comparison%20metrics%2C%20editorial%20business%20photography%2C%20soft%20diffused%20lighting%20from%20above%2C%20clean%20minimal%20presentation%2C%20warm%20terracotta%20olive%20and%20sand%20color%20palette%2C%20modern%20brand%20comparison%20aesthetic&width=600&height=400&seq=blog-card-v2-i9j0&orientation=landscape",
  },
  {
    slug: "como-encontrar-produtos-cssbuy-spreadsheet",
    title: "Como Encontrar Produtos no CSSBuy Spreadsheet",
    excerpt: "T&eacute;cnicas avan&ccedil;adas para localizar exatamente o que voc&ecirc; procura dentro do CSSBuy Spreadsheet. Filtros, busca por categoria e dicas exclusivas.",
    date: "Junho 2026",
    tag: "Dicas",
    image: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20product%20catalog%20page%20on%20a%20warm%20wooden%20desk%2C%20editorial%20search%20concept%20photography%2C%20dramatic%20spotlight%20effect%20on%20the%20glass%2C%20visible%20product%20images%20beneath%2C%20warm%20honey%20and%20cream%20tones%2C%20detective%20discovery%20aesthetic%2C%20clean%20sophisticated%20composition&width=600&height=400&seq=blog-card-v2-k1l2&orientation=landscape",
  },
  {
    slug: "erros-comuns-cssbuy-spreadsheet",
    title: "Erros Comuns ao Usar CSSBuy Spreadsheet",
    excerpt: "Evite os erros mais frequentes cometidos por iniciantes no CSSBuy Spreadsheet. Aprenda com a experi&ecirc;ncia de outros compradores e economize tempo.",
    date: "Junho 2026",
    tag: "Dicas",
    image: "https://readdy.ai/api/search-image?query=Red%20warning%20symbols%20floating%20above%20a%20cluttered%20desk%20with%20papers%20and%20laptop%2C%20editorial%20mistake%20prevention%20concept%20photography%2C%20dramatic%20side%20lighting%20with%20strong%20contrast%2C%20urgent%20yet%20professional%20atmosphere%2C%20warm%20terracotta%20and%20dark%20sand%20tones%2C%20teachable%20moment%20aesthetic&width=600&height=400&seq=blog-card-v2-m3n4&orientation=landscape",
  },
  {
    slug: "guia-completo-cssbuy-iniciantes",
    title: "Guia Completo CSSBuy para Iniciantes 2026",
    excerpt: "Tudo o que um iniciante precisa saber sobre CSSBuy Spreadsheet. Das configura&ccedil;&otilde;es iniciais at&eacute; a primeira compra bem-sucedida, explicado de forma simples.",
    date: "Junho 2026",
    tag: "Guia Essencial",
    image: "https://readdy.ai/api/search-image?query=Beginner%20friendly%20workspace%20with%20open%20notebook%20showing%20handwritten%20steps%20next%20to%20laptop%2C%20editorial%20learning%20concept%20photography%2C%20soft%20warm%20window%20light%2C%20encouraging%20peaceful%20atmosphere%2C%20coffee%20and%20plant%20accents%2C%20warm%20cream%20and%20olive%20tones%2C%20welcoming%20accessible%20aesthetic&width=600&height=400&seq=blog-card-v2-o5p6&orientation=landscape",
  },
  {
    slug: "como-economizar-cssbuy-spreadsheet",
    title: "Como Economizar Dinheiro com CSSBuy Spreadsheet",
    excerpt: "Estrat&eacute;gias comprovadas para reduzir custos nas suas compras internacionais usando CSSBuy Spreadsheet. Dicas de frete, taxas e fornecedores mais baratos.",
    date: "Junho 2026",
    tag: "Economia",
    image: "https://readdy.ai/api/search-image?query=Coins%20and%20savings%20jar%20on%20a%20warm%20desk%20beside%20laptop%20showing%20ecommerce%20interface%2C%20editorial%20savings%20concept%20photography%2C%20soft%20golden%20hour%20light%20creating%20warm%20glow%2C%20abundance%20and%20smart%20spending%20theme%2C%20warm%20terracotta%20and%20honey%20tones%2C%20optimistic%20financial%20aesthetic&width=600&height=400&seq=blog-card-v2-q7r8&orientation=landscape",
  },
  {
    slug: "cssbuy-spreadsheet-funciona-para-roupas",
    title: "CSSBuy Spreadsheet Funciona para Roupas?",
    excerpt: "Descubra se o CSSBuy Spreadsheet &eacute; a melhor op&ccedil;&atilde;o para comprar roupas da China. An&aacute;lise de tamanhos, qualidade dos tecidos e recomenda&ccedil;&otilde;es por categoria.",
    date: "Junho 2026",
    tag: "Moda",
    image: "https://readdy.ai/api/search-image?query=Stylish%20clothing%20items%20including%20sweaters%20and%20jackets%20artfully%20arranged%20on%20a%20warm%20cream%20surface%20with%20laptop%20showing%20fashion%20spreadsheet%2C%20editorial%20fashion%20tech%20photography%2C%20soft%20window%20light%2C%20warm%20sand%20terracotta%20and%20sage%20green%20palette%2C%20modern%20style%20meets%20data%20aesthetic&width=600&height=400&seq=blog-card-v2-s9t0&orientation=landscape",
  },
];

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-8 mb-12">
          <div className="lg:w-1/3">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
              Blog SEO
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Artigos &amp;<br />Guias Completos
            </h2>
          </div>
          <div className="lg:w-2/3 flex items-end">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              Nosso hub de conte&uacute;do SEO re&uacute;ne 10 artigos exclusivos e otimizados para ajudar voc&ecirc; a dominar o universo CSSBuy Spreadsheet. Cada artigo &eacute; escrito com foco em palavras-chave estrat&eacute;gicas para garantir a melhor experi&ecirc;ncia de busca no Google.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 group transition-all hover:-translate-y-1 cursor-pointer block"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-foreground-950 font-heading font-semibold text-lg mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="inline-flex items-center gap-1.5 text-primary-500 text-sm font-medium">
                    Leia mais <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}